import React from 'react'; // eslint-disable-line no-unused-vars
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Flex, Typo, Button } from '../../../ui';

const Container = styled(Flex)`
  padding: 20px;
  height: 100%;
  overflow-y: auto;
`;

const ModuleSettingsPanel = ({ module, onClose }) => {
  const { t } = useTranslation();

  if (!module) {
    return (
      <Container direction='column' gap='20' align='flex-start'>
        <Typo.MediumText fontWeight='600'>{t('editCourse.moduleSettings')}</Typo.MediumText>
        <Typo.SmallText>{t('editCourse.selectModuleToEdit')}</Typo.SmallText>
      </Container>
    );
  }

  const moduleType = module?.type?.name;

  return (
    <Container direction='column' gap='20' align='flex-start'>
      <Flex direction='column' gap='8' align='flex-start' width='100%'>
        <Typo.MediumText fontWeight='600'>{t('editCourse.moduleSettings')}</Typo.MediumText>
        <Typo.SmallText>{moduleType && `${moduleType.charAt(0).toUpperCase() + moduleType.slice(1)} Module`}</Typo.SmallText>
      </Flex>

      <Typo.Text>{t('editCourse.noSettings')}</Typo.Text>

      {onClose && (
        <Flex width='100%' justify='flex-end'>
          <Button onClick={onClose} variant='ghost'>
            {t('globals.close')}
          </Button>
        </Flex>
      )}
    </Container>
  );
};

export default ModuleSettingsPanel;
